import React, {useEffect, useRef, useState} from 'react';
import {navigate} from 'gatsby';
import styled from 'styled-components';
import {ChevronRight} from '@styled-icons/material/ChevronRight';
import {ChevronLeft} from '@styled-icons/material/ChevronLeft';
import {message} from 'antd';

export const PrevArrow = (props) => {
  const {style = {}, onClick} = props;
  return (
    <StyledButton onClick={onClick} style={style} className="circle left">
      <ChevronLeft />
    </StyledButton>
  );
};

export const NextArrow = (props) => {
  const {style = {}, onClick} = props;
  return (
    <StyledButton onClick={onClick} style={style} className="circle right">
      <ChevronRight />
    </StyledButton>
  );
};

const StyledButton = styled.button`
  cursor: pointer;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  border: none;
  box-shadow: 0 0 10px rgba(20, 20, 20, 0.1);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 200ms linear;
  opacity: 0.7;

  & > svg {
    fill: green;
    font-weight: bold;
  }

  &:hover {
    transform: translateY(-50%) scale(1.5);
    opacity: 1;
  }

  &:active {
    transform: translateY(-50%) scale(1.5);
    opacity: 1;
  }
`;

const StyledScrollSection = styled.div`
  position: relative;

  & > .list-container {
    display: flex;
    overflow-x: auto;
    padding: 20px 0;
    scroll-behavior: smooth;
    max-width: calc(100vw - 45px);

    ::-webkit-scrollbar {
      display: none;
    }
    & > .item {
      min-width: 248px;
      height: 400px;
      background-color: #fff;
      margin-right: 30px;
      border-radius: 20px;
      position: relative;
      cursor: pointer;
      transition: all 400ms ease;
      &:hover {
        transform: scale(1.05);
      }

      & > .corner-content {
        border-radius: 20px;
        padding: 10px;
        background-color: #0eb407;
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 26px;
        font-weight: 500;
        color: #fff;
      }
    }
  }

  & button.circle.left {
    left: 20px;
    z-index: 10;
  }

  & button.circle.right {
    right: 100px;
    z-index: 10;
  }
`;

function ScrollSection(props) {
  const {list = [], style = {}} = props;
  const scrollingRef = useRef(null);
  const listRef = useRef([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const item = listRef.current[currentIndex];
    const node = scrollingRef.current;
    node.scroll(item ? item.offsetLeft - 200 : 0, 0);
  }, [currentIndex]);

  return (
    <StyledScrollSection style={style}>
      {currentIndex > 0 && (
        <PrevArrow
          onClick={() => {
            setCurrentIndex((pre) => pre - 1);
          }}
        />
      )}
      {currentIndex < list.length - 1 && (
        <NextArrow
          onClick={() => {
            setCurrentIndex((pre) => pre + 1);
          }}
        />
      )}

      <div ref={scrollingRef} className="list-container">
        {list.map((f, idx) => (
          <div
            className="item"
            ref={(node) => {
              listRef.current[idx] = node;
            }}
            key={idx}
            onClick={async () => {
              if (!f.public) {
                message.info('尚未開放，敬請期待!');
                return;
              }
              await navigate(`/products?cat=${f.name}`);
            }}>
            <img
              src={f.image}
              alt="cat"
              style={{width: '100%', height: '100%', borderRadius: 20}}
            />
            <div className="corner-content">{f.display}</div>
          </div>
        ))}
      </div>
    </StyledScrollSection>
  );
}

export default ScrollSection;
